const GLOBAL_ALPHA = 'GA';
const GLOBAL_COMPOSITE_OPERATION = 'GCP';
const FILL_STYLE = 'FS';
const STROKE_STYLE = 'SS';
const DIRECTION = 'Dir';
const FONT = 'Fn';
const TEXT_ALIGN = 'TA';
const TEXT_BASE_LINE = 'TBL';
const LINE_WIDTH = 'LW';
const LINE_CAP = 'LC';
const MAX_WIDTH = 'MW';
const BEGIN_PATH = 'BP';
const CLOSE_PATH = 'CP';
const CLIP = 'Cl';
const FILL = 'Fl';
const STROKE = 'Stk';
const LINE_TO = 'LT';
const MOVE_TO = 'MT';
const SEGMENTS = 'Sgm';
const RECT = 'Rt';
const CLEAR_RECT = 'CR';
const FILL_RECT = 'FR';
const STROKE_RECT = 'SR';
const RESTORE = 'RES';
const SAVE = 'S';
const FILL_TEXT = 'FT';
const STROKE_TEXT = 'ST';
const SCALE = 'SC';
/**
 * @private
 */
export class DocumentCanvasElement {
    constructor() {
        this.style = {};
        this.context = new DocumentCanvasRenderingContext2D();
    }
    /**
     * @param {string} contextId - Specifies the type of context to create, 2d or webgl.
     * @param {CanvasRenderingContext2DSettings} options - Specifies the type of context to create, 2d or webgl.
     * @private
     * @returns {CanvasRenderingContext2D} - Returns the canvas rendering context 2D.
     */
    getContext(contextId, options) {
        return this.context;
    }
    /**
     * @param {string} type - Specifies the type of image to return.
     * @param {any} quality - A Number between 0 and 1 indicating the image quality to use for image formats that use lossy compression.
     * @private
     * @returns {string} - Returns the data URL containing a representation of the image in the format specified by the type parameter.
     */
    toDataURL(type, quality) {
        return this.context.renderedPath;
    }
}
/**
 * @private
 */
export class DocumentCanvasRenderingContext2D {
    constructor() {
        this.renderedPath = '';
    }
    set globalAlpha(value) {
        this.renderedPath += (GLOBAL_ALPHA + ':' + value + ';');
    }
    set globalCompositeOperation(value) {
        this.renderedPath += (GLOBAL_COMPOSITE_OPERATION + ':' + value + ';');
    }
    set fillStyle(value) {
        this.renderedPath += (FILL_STYLE + ':' + value + ';');
    }
    set strokeStyle(value) {
        this.renderedPath += (STROKE_STYLE + ':' + value + ';');
    }
    set direction(value) {
        this.renderedPath += (DIRECTION + ':' + value + ';');
    }
    set font(value) {
        this.renderedPath += (FONT + ':' + value + ';');
    }
    set textAlign(value) {
        this.renderedPath += (TEXT_ALIGN + ':' + value + ';');
    }
    set textBaseline(value) {
        this.renderedPath += (TEXT_BASE_LINE + ':' + value + ';');
    }
    set lineWidth(value) {
        this.renderedPath += (LINE_WIDTH + ':' + value + ';');
    }
    set lineCap(value) {
        this.renderedPath += (LINE_CAP + ':' + value + ';');
    }
    drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh) {
        this.renderedPath += (LINE_CAP + ':' + image.src + ';');
        this.renderedPath += ('sx:' + sx + ';');
        this.renderedPath += ('sy:' + sy + ';');
        this.renderedPath += ('sw:' + sw + ';');
        this.renderedPath += ('sh:' + sh + ';');
        if (dx) {
            this.renderedPath += ('dx:' + dx + ';');
        }
        if (dy) {
            this.renderedPath += ('dy:' + dy + ';');
        }
        if (dw) {
            this.renderedPath += ('dw:' + dw + ';');
        }
        if (dh) {
            this.renderedPath += ('dh:' + dh + ';');
        }
    }
    beginPath() {
        this.renderedPath += (BEGIN_PATH + ';');
    }
    clip(fillRule) {
        this.renderedPath += (CLIP + ';');
    }
    fill(fillRule) {
        this.renderedPath += (FILL + ';');
    }
    stroke() {
        this.renderedPath += (STROKE + ';');
    }
    closePath() {
        this.renderedPath += (CLOSE_PATH + ';');
    }
    lineTo(x, y) {
        this.renderedPath += (LINE_TO + ':' + 'x:' + x + ';' + 'y:' + y + ';');
    }
    moveTo(x, y) {
        this.renderedPath += (MOVE_TO + ':' + 'x:' + x + ';' + 'y:' + y + ';');
    }
    rect(x, y, w, h) {
        this.renderedPath += (RECT + ':' + 'x:' + x + ';' + 'y:' + y + ';' + 'w:' + w + ';' + 'h:' + h + ';');
    }
    setLineDash(segments) {
        this.renderedPath += (SEGMENTS + ':' + segments.toString() + ';');
    }
    clearRect(x, y, w, h) {
        this.renderedPath += (CLEAR_RECT + ':' + 'x:' + x + ';' + 'y:' + y + ';' + 'w:' + w + ';' + 'h:' + h + ';');
    }
    fillRect(x, y, w, h) {
        this.renderedPath += (FILL_RECT + ':' + 'x:' + x + ';' + 'y:' + y + ';' + 'w:' + w + ';' + 'h:' + h + ';');
    }
    strokeRect(x, y, w, h) {
        this.renderedPath += (STROKE_RECT + ':' + 'x:' + x + ';' + 'y:' + y + ';' + 'w:' + w + ';' + 'h:' + h + ';');
    }
    restore() {
        this.renderedPath += (RESTORE + ';');
    }
    save() {
        this.renderedPath += (SAVE + ';');
    }
    fillText(text, x, y, maxWidth) {
        this.renderedPath += (FILL_TEXT + ':' + text + ';' + 'x:' + x + ';' + 'y:' + y + ';');
        if (maxWidth) {
            this.renderedPath += (MAX_WIDTH + ':' + maxWidth + ';');
        }
    }
    measureText(text) {
        return { width: 30 };
    }
    strokeText(text, x, y, maxWidth) {
        this.renderedPath += (STROKE_TEXT + ':' + text + ';' + 'x:' + x + ';' + 'y:' + y + ';');
        if (maxWidth) {
            this.renderedPath += (MAX_WIDTH + ':' + maxWidth + ';');
        }
    }
    scale(x, y) {
        this.renderedPath += (SCALE + ':' + 'x:' + x + ';' + 'y:' + y + ';');
    }
}
